module.exports = __webpack_public_path__ + "ath_game_web/img/2.1.2726a909.png";